import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Ear } from "lucide-react";
import { useTr } from "@/i18n/translator";

const SENT_COLOR = {
  positivo: "bg-[#E53935] text-white",
  neutro: "bg-[#E5E5E5] text-[#0A0A0A]",
  negativo: "bg-[#0A0A0A] text-[#FFD600]",
};

export default function SocialListening() {
  const tr = useTr();
  const [kws, setKws] = useState([]);
  const [mentions, setMentions] = useState([]);
  const [kw, setKw] = useState("");

  const load = async () => {
    const [a, b] = await Promise.all([
      api.get("/listening/keywords"),
      api.get("/listening/mentions"),
    ]);
    setKws(a.data);
    setMentions(b.data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (kw.trim().length < 2) return toast.error(tr("Mínimo 2 caracteres"));
    await api.post("/listening/keywords", { keyword: kw.trim() });
    setKw("");
    load();
  };
  const remove = async (id) => { await api.delete(`/listening/keywords/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="listening-page">
      <div>
        <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("VIGILANCIA · MENCIONES")}</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2">Social listening</h1>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white border border-[#0A0A0A] p-6">
          <div className="font-mono-mark text-[10px] text-[#5C5C5C] mb-3">{tr("KEYWORDS VIGILADAS")}</div>
          <div className="flex gap-2 mb-4">
            <input value={kw} onChange={(e) => setKw(e.target.value)} placeholder={tr("mi marca, producto…")} className="flex-1 bg-white border border-[#0A0A0A] px-3 py-2 font-mono-data text-sm" data-testid="listen-input" />
            <button onClick={add} className="bg-[#0A0A0A] text-white px-3 py-2 border border-[#0A0A0A]" data-testid="listen-add"><Plus className="w-4 h-4" /></button>
          </div>
          {kws.length === 0 ? (
            <div className="font-mono-data text-xs text-[#5C5C5C] border border-dashed border-[#0A0A0A] p-4 text-center">
              {tr("Aún no hay keywords. Agrega al menos una.")}
            </div>
          ) : (
            <ul className="space-y-2">
              {kws.map((k) => (
                <li key={k.id} className="flex items-center justify-between border border-[#0A0A0A] px-3 py-2" data-testid={`listen-kw-${k.id}`}>
                  <span className="font-mono-data text-sm">#{k.keyword}</span>
                  <button onClick={() => remove(k.id)} className="text-[#E53935]"><Trash2 className="w-3 h-3" /></button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="md:col-span-2 bg-white border border-[#0A0A0A] p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("FLUJO EN VIVO · ÚLTIMAS MENCIONES")}</div>
            <span className="font-mono-mark text-[10px] text-[#E53935]">{mentions.length} HITS</span>
          </div>
          {mentions.length === 0 ? (
            <div className="border border-dashed border-[#0A0A0A] p-8 text-center">
              <Ear className="w-7 h-7 mx-auto text-[#5C5C5C]" />
              <div className="font-mono-mark text-[10px] text-[#5C5C5C] mt-2">{tr("SIN MENCIONES")}</div>
              <div className="text-sm mt-1">{tr("Agrega al menos un keyword para ver actividad.")}</div>
            </div>
          ) : (
            <ul className="divide-y divide-[#0A0A0A] max-h-[600px] overflow-y-auto">
              {mentions.map((m) => (
                <li key={m.id} className="py-3 flex items-start gap-3">
                  <span className={`font-mono-mark text-[9px] px-2 py-1 ${SENT_COLOR[m.sentiment]}`}>{m.sentiment.toUpperCase()}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 text-xs text-[#5C5C5C] font-mono-data">
                      <span>{m.network}</span>·<span>{m.author}</span>·<span>{new Date(m.date).toLocaleString("es-MX")}</span>
                    </div>
                    <p className="text-sm mt-1">{m.text}</p>
                  </div>
                  <span className="font-mono-data text-xs text-[#5C5C5C]">{m.reach.toLocaleString()} alcance</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
